// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_HEr","content":"styles_content__2L2XL"};